<template>
	<div class="footer">
    <div class="title">{{ title }}</div>
    <div class="btn-box" @click="goUrl(buttonLink)"><div class="btn">{{ buttonText }}</div></div>
    <div class="footer-copyright-box">{{ copyrightText }}</div>
	</div>
</template>

<script>
	export default {
    props: {
      title: {
        type: String,
        default: '接入灰鲸广告联盟，开启APP广告变现之旅!'
      },
      buttonText: {
        type: String,
        default: '立即接入'
      },
      buttonLink: {
        type: String,
        default: 'https://admin.huimiaokeji.com'
      },
      copyrightText: {
        type: String,
        default: '隐私政策 浙ICP备2023006293号-1 Copyright © 2023 杭州灰喵科技有限公司. AII Rights Reserved'
      }
    },
		data() {
			return {
			}
		},
		methods: {
			goUrl(url){
					   window.open(url);
			}
		}
	}
</script>

<style lang="less">
	.footer{
		width: 100%;
		height: 398px;
		background: url(https://cdn.huimiaokeji.com/hjweb/bg_bottom.jpg) no-repeat;
		background-size: 100% 398px;
		position: relative;
		text-align: center;
		.title {
			padding-top: 80px;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 34px;
			color: #FFFFFF;
			line-height: 34px;
			text-align: center;
			font-style: normal;
		}
		.btn-box {
			width: 100%;
			height: 60px;
			display: flex;
			justify-content: center;
			.btn {
				margin-top: 50px;
				width: 164px;
				height: 60px;
				border: 1px solid #FFFFFF;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 60px;
				text-align: center;
				font-style: normal;
				cursor: pointer;
			}
		}
		.footer-copyright-box {
			width: 100%;
			height: 94px;
			background: rgba(255,255,255,0.2);
			//opacity: 0.8;
			position: absolute;
			bottom: 0;
			left: 0;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 14px;
			color: #FFFFFF;
			line-height: 94px;
			text-align: center;
			font-style: normal;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/footer-menu.vue